import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { ColorOrKey } from "@faire/web--source/slate/Color";
import { FoundationLock } from "@faire/web--source/slate/icons/foundation/Lock";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
import type { JSX } from "react";
import styled from "styled-components";

export const Privacy: React.FC<{
  color?: ColorOrKey;
}> = ({ color }) => (
  <Row>
    <Column>
      <Spacer height={4} />
      <StyledLockIcon color={color || Core.icon.subdued} />
    </Column>
    <Spacer size="1x" />
    <Typography variant="labelSansRegular" color={color}>
      <StrictLocalMsg
        defaultMessage="Learn more about how we use and protect your data at Faire. <LinkFormatting>Privacy at Faire</LinkFormatting>"
        description={{
          text: "Footer that directs users to learn more about how Faire uses and protects their data on the Faire website, with a link to the privacy policy page.",
        }}
        values={{
          LinkFormatting: (chunks: JSX.Element) =>
            LinkFormatting(chunks, color),
        }}
      />
    </Typography>
  </Row>
);

const StyledLockIcon = styled(FoundationLock).attrs({
  fontSize: "12px",
  strokeWidth: 1.5,
})`
  margin-top: -1px;

  ${responsiveMediaQueries.mobile} {
    margin-top: -3px;
  }
`;

const LinkFormatting = (chunks: JSX.Element, color?: ColorOrKey) => (
  <PrivacyButton tertiaryColor={color || Core.text.default}>
    {chunks}
  </PrivacyButton>
);

const PrivacyButton = styled(Button).attrs({
  variant: "tertiary",
  linkTo: "/privacy",
  target: "_blank",
})`
  font-family: inherit;
  font-size: inherit;
`;
